import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useConfig } from '~components/hooks';

import Container from '~frontend/components/container';
import TextHeading from '~frontend/components/text-heading';
import '../../scss/pages/_terms.scss';

export default function Refunds() {
  const { t } = useTranslation();
  const getConfig = useConfig();

  return (
    <>
      <Helmet>
        <title>
          {t('CSCASE Refund Policy', { hostname: getConfig?.hostname })}
        </title>
        <meta
          name="description"
          content={t(
            `Check out CSCASE's Refund Policy, if you have any questions - contact support on the left side of the screen`,
            { hostname: getConfig?.hostname },
          )}
        />
      </Helmet>

      <div className="page-terms">
        <div className="text_page">
          <Container>
            <TextHeading title="funds_return_policy" />
          
            <div className="page_item">
              <p>
                {t('refund_policy_line1', {
                  hostname: getConfig?.hostname,
                })}
              </p>
              <p>
                {t('refund_policy_line2', {
                  hostname: getConfig?.hostname,
                })}
              </p>
              <p>
                {t('refund_policy_line3', {
                  hostname: getConfig?.hostname,
                })}
              </p>
              <p>{t('refund_policy_line4')}</p>
            </div>
          </Container>
        </div>
      </div>
    </>
  );
}
